<template>
    <header class="relative border-b border-zinc-300 font-division-heading" :class="{ 'lg:hidden': showSpaLayout }">
        <div v-if="!ready">
            <slot></slot>
        </div>
        <div v-else class="max-w-screen-xl mx-auto flex items-center px-5 py-3" :class="[ showSpaLayout ? 'justify-center' : 'justify-between' ]">
            <a :href="logoHref">
                <img class="h-12" :src="logoUrl" alt="Unbundled Legal Help">
            </a>

            <div class="hidden lg:flex justify-between">
                <nav class="space-x-16">
                    <a class="col-span-1 text-sm font-medium uppercase" href="#who-is-unbundled">About Us</a>
                    <a class="col-span-1 text-sm font-medium uppercase" href="#sector-cards">Services</a>
                    <a class="col-span-1 text-sm font-medium uppercase" href="#testimonials">Testimonials</a>
                    <a class="col-span-1 text-sm font-medium uppercase" href="#faqs">FAQ</a>
                </nav>
            </div>

            <div class="flex items-center space-x-5">
                <img class="w-14" src="/assets/img/theme/us-flag.svg" alt="US Flag" />
                <img class="w-14 hidden sm:block" src="/assets/img/theme/10y-sign.png" alt="10 Years of Service" />

                <div v-if="!showSpaLayout" class="w-10 flex justify-center lg:hidden">
                    <svg @click="toggle" class="text-brand-blue" width="39" height="28" viewBox="0 0 39 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="39" height="4" fill="currentColor"/>
                        <rect y="12" width="39" height="4" fill="currentColor"/>
                        <rect y="24" width="39" height="4" fill="currentColor"/>
                    </svg>
                </div>
            </div>
        </div>

        <transition
            enter-active-class="transition-opacity duration-150 ease-linear"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity duration-150 ease-linear"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div v-show="open" class="relative z-20 flex justify-center">
                <div class="fixed inset-0 z-40" @click="toggle">
                    <div class="absolute inset-0 bg-zinc-500 opacity-70"></div>
                </div>
                <div class="fixed top-0 z-50 w-full">
                    <div class="flex justify-between items-center bg-white border-b border-zinc-300 px-5 py-3">
                        <a :href="logoHref">
                            <img class="h-12" :src="logoUrl" alt="Unbundled Legal Help">
                        </a>

                        <div class="w-10 flex justify-center lg:hidden">
                            <svg @click="toggle" class="text-brand-blue" width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="30.4053" y="3.18164" width="39" height="4" transform="rotate(135 30.4053 3.18164)" fill="currentColor"/>
                                <rect x="3.18164" width="39" height="4" transform="rotate(45 3.18164 0)" fill="currentColor"/>
                            </svg>
                        </div>
                    </div>
                    <div class="flex bg-neutral-100 px-5 py-8">
                        <nav class="w-full grid grid-cols-2 gap-5">
                            <a class="col-span-1 text-2xl font-light" href="#who-is-unbundled">About Us</a>
                            <a class="col-span-1 text-2xl font-light" href="#division">Services</a>
                            <a class="col-span-1 text-2xl font-light" href="#testimonials">Testimonials</a>
                            <a class="col-span-1 text-2xl font-light" href="#faqs">FAQ</a>
                        </nav>
                    </div>
                </div>
            </div>
        </transition>
    </header>
</template>

<script>
import { mapGetters } from 'vuex';
import state from '../store/state';

export default {
    props: {
        logoUrl: {
            type: String,
            required: true,
        },
        logoHref: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            ready: false,
            open: false,
        }
    },

    methods: {
        toggle() {
            this.open = !this.open;
        }
    },

    computed: {
        ...mapGetters([
            'showSpaLayout',
        ]),
    },

    created() {
        this.$store.registerModule('call', state);
        this.ready = true;
    },
}
</script>
